<template>
  <div class="homepage__info">
    <div class="homepage__info-wrapper">
      <div class="homepage__info__slogan">
        Interviews<br />on democracy's<br />past, present<br />and future.
      </div>
      <div class="homepage__info__logo" v-show="hasVideos">
        <img src="../../assets/logo.png" />
        <h2>Season {{ currentVideo.season }}</h2>
      </div>
      <div class="homepage__info__episode" v-show="hasVideos">
        <h2>Episode {{ currentVideo.order }}</h2>
        <h1>{{ currentVideo.title }}</h1>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.homepage {
      &__info {
        position: absolute;
        width: 100%;
        height: 100%;
        max-height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        overflow: hidden;
        // background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);
        background-color: rgba(17, 24, 41, 0.65);

        &--wrapper {
          position: relative;
          width: 100%;
          height: 100%;
        }

        &__slogan {
          position: absolute;
          top: 85px;
          left: 132px;
          font-size: 8vh;
          font-weight: 300;
          letter-spacing: 1.33px;
          line-height: 1.05em;
        }

        &__logo {
          position: absolute;
          top: 70px;
          right: 250px;

          img { width: 243px; }
          h2 {
            padding-top: 8px;
            text-align: right;
            color: #fc8b00;
            font-size: 1.5em;
            font-weight: 700;
            letter-spacing: 2.75px;
            text-transform: uppercase;
          }

          @include media-breakpoint-x-large {
            right: 250px;

            img {
              width: 304px;
            }
          }
        }

        &__episode {
          position: absolute;
          text-align: right;
          // width: 48vh;
          max-width: 46vh;
          top: 63px;
          right: 180px;
          transform-origin: right top;
          transform: rotateZ(-90deg);
          // background:blue;

          h2 {
            color: #fc8b00;
            font-size: 1.5em;
            font-weight: 700;
            letter-spacing: 2.75px;
            line-height: 30px;
            text-transform: uppercase;
          }

          h1 {
            color: #ffffff;
            font-size: 7vh;
            font-weight: 700;
            letter-spacing: 0.025em;
            text-transform: uppercase;
            margin-right: -7px;
            line-height: 1em;
            // transform: rotateZ(-90deg);
          }

          @media (min-width: 100em) {
            max-width: 50vh;

            h2 {
              font-size: 1.25em;
              letter-spacing: 3.5px;
            }

            h1 {
              font-size: 2.725em;
              line-height: 54px;
              letter-spacing: 9px;
            }
          }
        }
      }
    }
</style>

<script>
export default {
  computed: {
    videoList () {
      return this.$store.state.videoList
    },
    hasVideos () {
      return this.$store.getters.hasVideos
    },
    currentVideo () {
      return this.hasVideos ? this.$store.state.videoList[this.$store.state.currentVideo] : this.$store.getters.emptyEpisode
    }
  }
}
</script>
